import { FormLegalDisclaimer } from "@justhome/react-ui";
import useLanguage from "@lib/hooks/useLanguage";
import usePartnerContext from "@lib/hooks/usePartnerContext";

export const LegalDisclaimer = ({ className }: { className?: string }) => {
  const locale = useLanguage();
  const { partner } = usePartnerContext();

  return (
    <FormLegalDisclaimer
      locale={locale}
      partner={partner}
      className={className}
    />
  );
};
